import react from 'react';
import { useEffect, useRef  } from 'react';
import First from './initialPage.jsx';
import Second from './secondPage.jsx';
import Third from './features.jsx';
import Fourth from './specificationPage.jsx';
import Fifth from './query.jsx';
import Six from './deploymentContent.jsx'
import Footer from '../Home/Footer.jsx'
import logo from '../Assests/images/AiKisokLogo.png'
// import Header from './header.jsx'
import './kiosk.css';
import Header from '../Home/Navbar.jsx'



const KioskLandingPage = () => {
  const queryRef = useRef(null);

  const scrollToQuery = () => {
    queryRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  
  useEffect(() => {
    let params = new URL(document.location).searchParams;
    let emailTemplate = params.get("key");
    if (emailTemplate === "Newsletter") {
      MailTracker('KioskRegister');
    }

  }, []);

  const MailTracker = async (value) => {
    const payload = { key: value };

    try {
      const response = await fetch('https://api.tele.ayurai.in/NewsletterTracker', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };
  return (
    <>
      <Header/>
      <First scrollToQuery={scrollToQuery}/>
      <Second />
      <Third />
      <Fourth />
      <div ref={queryRef}>
        <Fifth />
      </div>
      <Six />
      <Footer />
    </>
  );
}

export default KioskLandingPage;

